"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const new_item_1 = __importDefault(require("./new-item"));
class NewDeviceCategory extends new_item_1.default {
    constructor(newDeviceCategory) {
        super();
        this.name = newDeviceCategory.name;
        this.organisationId = newDeviceCategory.organisationId;
        this.colour = newDeviceCategory.colour;
        this.icon = newDeviceCategory.icon;
        this.global = newDeviceCategory.global;
        this.assetIds = newDeviceCategory.assetIds;
        this._permission = newDeviceCategory._permission;
    }
}
exports.default = NewDeviceCategory;
//# sourceMappingURL=new-deviceCategory.js.map